import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { getMISheaders, getMIShtmlExcel } from '../auth/services/privateapicalling'
import { useSelector } from 'react-redux';

const DownloadExcelMIS = () => {
    const [apiHeaderResponse, setApiHeaderResponse] = useState([])
    const [selectedMonth, setSelectedMonth] = useState('')
    const [selectedYear, setSelectedYear] = useState('')
    const [selectedHeader, setSelectedHeader] = useState(null)
    const [htmlData, setHtmlData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [apiHtmlResponse, setApiHtmlResponse] = useState([])


    const token = useSelector((state: any) => state.auth.token);
    
    useEffect(() => {
        const fetchHeaders = async () => {
            try {
                const response = await getMISheaders(token);
               
                
                // Check if response has the expected structure
                if (response?.success && response?.data) {
                    setApiHeaderResponse(response.data);
                }
            } catch (error) {
               
            }
        }
        
        fetchHeaders();
    }, [token])

    // Transform API data to react-select format
    const selectOptions = apiHeaderResponse.map(item => ({
        value: item.id,
        label: item.header_name
    }))

    // Month options
    const monthOptions = [
        { value: '01', label: 'January' },
        { value: '02', label: 'February' },
        { value: '03', label: 'March' },
        { value: '04', label: 'April' },
        { value: '05', label: 'May' },
        { value: '06', label: 'June' },
        { value: '07', label: 'July' },
        { value: '08', label: 'August' },
        { value: '09', label: 'September' },
        { value: '10', label: 'October' },
        { value: '11', label: 'November' },
        { value: '12', label: 'December' }
    ]

    // Generate year options (e.g., last 5 years to next year)
    const currentYear = new Date().getFullYear()
    const yearOptions = Array.from({ length: 7 }, (_, i) => {
        const year = currentYear - 5 + i
        return { value: year.toString(), label: year.toString() }
    })

    const handleSubmit = async () => {
   

        // Fetch HTML data when button is clicked
        setLoading(true)
        try {
            const response = await getMIShtmlExcel(token, selectedMonth, selectedYear, selectedHeader?.value);
        
            
            if (response?.success && response?.htmlContent) {
              
                setHtmlData(response.htmlContent);
            } else {
               
                setHtmlData(response.message)
            }
        } catch (error) {
      
            setHtmlData(null)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className='page-wrapper'>
            <div className='p-4'>
                <h2>MIS Preview</h2>
                <p>Please enter the corresponding values</p>

                <div className='d-flex justify-content-between gap-4 mb-3'>
                    <div className='w-100'>
                        <label className='form-label'>Month</label>
                        <Select
                            options={monthOptions}
                            onChange={(selectedOption) => setSelectedMonth(selectedOption?.value)}
                            placeholder="Select Month"
                        />
                    </div>
                    
                    <div className='w-100'>
                        <label className='form-label'>Year</label>
                        <Select
                            options={yearOptions}
                            onChange={(selectedOption) => setSelectedYear(selectedOption?.value)}
                            placeholder="Select Year"
                        />
                    </div>
                    
                    <div className='w-100'>
                        <label className='form-label'>Report Type</label>
                        <Select
                            options={selectOptions}
                            onChange={(selectedOption) => setSelectedHeader(selectedOption)}
                            placeholder="Select Report"
                            isLoading={apiHeaderResponse.length === 0}
                        />
                    </div>
                </div>

                <button 
                    className='btn btn-primary'
                    onClick={handleSubmit}
                    disabled={!selectedMonth || !selectedYear || !selectedHeader || loading}
                >
                    {loading ? 'Loading...' : 'Show Report'}
                </button>

                {/* Display HTML content */}
                {htmlData ? (
                    <div className='mt-4'>
                        <h3 className='mb-2'>Report Preview</h3>
                        <div 
                            className='border p-3'
                            style={{ 
                                overflow: 'auto', 
                                maxHeight: '600px',
                                backgroundColor: '#fff' 
                            }}
                        >
                            <style>
                                {`
                                    .report-table table {
                                        border-collapse: collapse;
                                        width: 100%;
                                        font-family: Arial, sans-serif;
                                        font-size: 12px;
                                    }
                                    .report-table table td {
                                        border: 1px solid #000;
                                        padding: 8px;
                                        text-align: left;
                                        vertical-align: middle;
                                        min-height: 30px;
                                    }
                                    .report-table table tr {
                                        border: 1px solid #000;
                                    }
                                `}
                            </style>
                            <div 
                                className='report-table'
                                dangerouslySetInnerHTML={{ __html: htmlData }}
                            />
                        </div>
                    </div>
                ) : apiHtmlResponse}
            </div>
        </div>
    )
}

export default DownloadExcelMIS